<template>
    <base-side-bar>
        <div class="flex flex-col items-center justify-center w-full mx-10">
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 text-xxxl sm:text-xl sm:leading-10"
            >
                Moyens fonciers et immeubles
            </h2>
            <br />
            <div
                class="flex flex-col items-center justify-center flex-grow w-full"
            >
                <wide-card
                    title="Offre foncière de la Région  Marrakech-Safi"
                    titleClass="text-center mb-2"
                    :info="true"
                    @modal="isOpen = !isOpen"
                >
                       <!--  <base-tips-alert>
                        <p class="my-0 mt-1 text-gray-700">
                            Veillez à ne pas « sous-dimensionner » ou «
                            sur-dimensionner » votre projet sur le plan moyens
                            fonciers et immeubles.
                        </p>
                        <p class="my-0 mt-1 text-gray-700">
                            Selon votre activité et vos besoins, vous pouvez
                            opter pour la location ou pour l'achat.
                        </p>
                        <p class="my-0 mt-1 text-gray-700">
                            La location permet une flexibilité avantageuse pour
                            les jeunes entreprises (ne freine pas leur évolution
                            et évite l'endettement pour l'achat d'immeubles).
                        </p>
                        <p class="my-0 mt-1 text-gray-700">
                            L'achat est une solution idéale pour les entreprises
                            et les entrepreneurs matures (car il permet de
                            constituer un capital), finis l'argent jeté par les
                            fenêtres (synonyme de sécurité et d'engagement à
                            long terme).
                        </p>
                    </base-tips-alert>-->
                    <base-info-modal
                        @modal-close="isOpen = false"
                        :open="isOpen"
                        :isIframe="true"
                    >
                        <!-- Modal Content -->
                        <article class="prose lg:prose-sm">
                            <iframe
                                src="https://orientalinvest.ma/foncier-bpi-embed/"
                                title="foncier map"
                                style="position: relative; width: 1060px; height: 700px"
                            ></iframe>
                        </article>
                        <!-- / Modal Content -->
                        <!-- <p class="text-sm leading-5 text-gray-500">
              Are you sure you want to deactivate your account? All of your data will be permanently removed. This action cannot be undone.
            </p> -->
                    </base-info-modal>
                </wide-card>
                <component
                    ref="buildings"
                    v-for="(construction, index) in constructions"
                    :key="index"
                    :is="construction.model"
                    :data="construction.object"
                    v-on:remove="removeConstruction($event, index)"
                />
                <base-add-button
                    title="Ajouter Moyens fonciers et immeubles"
                    @click="addImmeubleCard"
                />

                <div
                    class="grid items-center justify-center w-full grid-cols-10 "
                >
                    <base-primary-button
                        title="Suivant"
                        @click="nextStep"
                        class="w-full col-span-6 col-start-3"
                    />
                    <div
                        @click="skipStep"
                        class="flex items-center justify-center col-span-2 col-start-9 p-3 mb-6 space-x-2 text-gray-500 cursor-pointer hover:underline hover:text-gray-800 "
                    >
                        <span>Ignorer cette étape</span>
                        <svg
                            class="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M13 5l7 7-7 7M5 5l7 7-7 7"
                            ></path>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </base-side-bar>
</template>

<script>
import ImmeubleCard from "./Moyens_fonciers_et_immeubles/ImmeubleCard";
import WideCard from "../../../components/cards/wideCard";
import { mapState, mapGetters } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        ImmeubleCard,
        WideCard
    },
    data() {
        return {
            // constructions: ["ImmeubleCard"],
            constructions: [],

            isOpen: false
        };
    },
    mixins: [scrollToError],

    mounted() {
        this.constructions = this.$store.getters[
            "EtudeTechnique/getConstructionsData"
        ];
    },

    created() {
        this.$store.dispatch("forms/showSection", "Étude Technique");
        this.$store.dispatch("forms/stepFocus", "Moyens fonciers et immeubles");
    },
    methods: {
        skipStep() {
            if (this.isSimplifiedVersion) {
                this.$router.push({
                    name: "i_t_m_o",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.$router.push({
                    name: "installations_techniques",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            }
            this.$store.dispatch(
                "forms/subStepComplete",
                "Moyens fonciers et immeubles"
            );
        },
        addImmeubleCard() {
            if (!this.checkForms()) {
                this.constructions.push({
                    model: "immeuble-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        image: null,
                        buildingType: "terrain",
                        isBuying: "Achat",
                        hasLeasing: true,
                        isRural: false,
                        address: "",
                        Superficie: null,
                        price: null,
                        rent: null,
                        constructionEntry: "quantity",
                        constructionCosts: {
                            batiment: { surface: null, price: null },
                            charpante: { surface: null, price: null },
                            ConstruitEnDur: { surface: null, price: null },
                            fondation: { surface: null, price: null },
                            dallage: { surface: null, price: null },
                            mure: { surface: null, price: null }
                        },
                        constructionTotal: null,
                        FCD: false,
                        amenagment: null,
                        landTitle: null,
                        formJuridique: null,
                        payedInAdvance: null,
                        rentPrice: null,
                        rentDuration: null
                    }
                });

                this.$refs.buildings[
                    this.$refs.buildings.length - 1
                ].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        removeConstruction(payload, index) {
            this.$store.dispatch("EtudeTechnique/removeConstruction", payload);
            this.constructions.splice(index, 1);
        },
        nextStep() {
            if (!this.checkForms() && this.constructionLength >= 1) {
                this.$store.dispatch("EtudeTechnique/SaveConstructionData");
                this.$store.dispatch(
                    "forms/subStepComplete",
                    "Moyens fonciers et immeubles"
                );
                if (this.isSimplifiedVersion) {
                    this.$router.push({
                        name: "i_t_m_o",
                        params: { uid: `${this.$store.state.user.bpiId}` }
                    });
                } else {
                    this.$router.push({
                        name: "installations_techniques",
                        params: { uid: `${this.$store.state.user.bpiId}` }
                    });
                }
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.buildings.forEach(building => {
                if (!building.createConstruction()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        }
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapState("EtudeTechnique", {
            constructionLength: state => state.constructionsData.length
        })
    }
};
</script>

<style></style>
